import DetailsView from './DetailsView';

export default DetailsView;
